import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { ConditionLinksContent } from './components/ConditionLinksContent';
import { PageWithLayout } from '@/models/page';
import { Permission } from '@/models/user';

const ConditionLinkPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Regelwerke | Starjack Admin</title>
            </Helmet>

            <ConditionLinksContent />
        </>
    );
};

ConditionLinkPage.isProtected = true;
ConditionLinkPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
ConditionLinkPage.permissions = [Permission.CONDITION_LINKS_NAV];

export default ConditionLinkPage;
